/* Copyright 2014 The MathWorks, Inc. */

/**
 * This defines a list of constants which represent the different components of the toolstrip.
 */

define([
    "dojo/_base/lang",
    "MW/statusbar/TypeConstants",
    "MW/toolstrip/constants/TypeConstants"
], function (lang, StatusBarTypeConstants, ToolstripTypeConstants) {
    var hash = {
        ROOT: "Root",
        ORPHAN_ROOT: "OrphanRoot"
    };

    lang.mixin(hash, StatusBarTypeConstants);
    lang.mixin(hash, ToolstripTypeConstants);

    return hash;
});